<template>
  <v-dialog v-model="dialog" max-width="700" :fullscreen="isMobile()" scrollable>
    <v-card>
      <toolbar-card-visita :opcao_checklist="checklist" />

      <v-card-text class="pt-5">
        <slider-imagens-visita categoria="silagem" />

        <!-- input escondido (múltiplos PDFs) -->
        <input
          ref="anexarLaudo"
          accept="application/pdf"
          type="file"
          multiple
          v-show="false"
          @change="onSelectMultiple"
        />

        <!-- Card de laudos (lista) -->
        <v-card flat outlined class="mt-4" rounded="lg">
          <v-card-text class="py-3">
            <v-row align="center" no-gutters>
              <v-col>
                <div class="font-weight-bold subtitle-1">Laudos análise silagem</div>
                <div class="text--secondary">
                  Anexe um ou mais laudos bromatológicos da silagem (PDF), se disponível
                </div>
              </v-col>


              <v-col cols="auto">
                <v-btn
                  color="primary"
                  outlined
                  class="font-weight-bold"                  
                  :disabled="carregandoLaudo"
                  @click="$refs.anexarLaudo.click()"
                >
                  <v-icon left small>mdi-upload</v-icon>
                  Adicionar
                </v-btn>
              </v-col>
            </v-row>

            <v-divider class="my-3" />

            <div v-if="carregandoLaudo" class="text-caption font-italic">
              Carregando laudos...
            </div>

            <div v-else-if="laudosAnexados.length === 0" class="text-caption text--secondary">
              Nenhum laudo anexado ainda.
            </div>

            <v-list v-else two-line class="py-0">
              <v-list-item
                v-for="(doc, i) in laudosAnexados"
                :key="doc._key || (doc.id + '-' + i)"
                class="grey lighten-4 mb-2"
                style="border-radius: 10px;"
              >
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ doc.nome || `Laudo Silagem ${i + 1}` }}
                  </v-list-item-title>

                  <!-- <v-list-item-subtitle class="success--text">
                    <v-icon color="success" x-small left>mdi-file-check-outline</v-icon>
                    Arquivo anexado
                  </v-list-item-subtitle> -->
                </v-list-item-content>

                <v-list-item-action>
                  <v-row no-gutters>
                    <v-btn
                      icon
                      color="grey"
                      title="Visualizar laudo"
                      @click="abrirPreview(doc)"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>

                    <v-btn
                      icon
                      color="error"
                      title="Remover laudo"
                      @click="removerLaudo(doc)"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>

        <v-row class="mt-4">
          <v-col cols="12">
            <v-textarea
              rows="6"
              outlined
              label="Observações silagem"
              placeholder="Ex.: odor, textura, presença de bolores, coloração, temperatura, condição do silo."
              persistent-placeholder
              v-model="visita.obs_silagem"
              auto-grow
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <btn-salvar-dados-visita />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import BtnSalvarDadosVisita from "./BtnSalvarDadosVisita.vue";
import ToolbarCardVisita from "./ToolbarCardVisita.vue";
import SliderImagensVisita from "./SliderImagensVisita.vue";
import { mapActions, mapState } from "vuex";
import { toBase64 } from "@/global";

export default {
  components: { ToolbarCardVisita, BtnSalvarDadosVisita, SliderImagensVisita },

  data: () => ({
    dialog: false,
    checklist: {
      descricao: "Silagem",
      icone: "mdi-corn",
    },
    categoria: "laudo-silagem",
    carregandoLaudo: true,
  }),

  watch: {
    dialog(open) {
      if (!open) this.$router.go(-1);
    },
  },

  computed: {
    ...mapState("visitaTecnica", ["visita"]),

    laudosAnexados() {
      return (this.visita.docs || []).filter(
        (d) => (d.categoria || "").toLowerCase() === this.categoria
      );
    },
  },

  methods: {
    ...mapActions("visitaTecnica", ["buscarDocumento", "abrirPreview"]),

    isMobile() {
      return this.$mq == "sm";
    },

    async onSelectMultiple() {
      const files = Array.from(this.$refs.anexarLaudo.files || []);
      if (!files.length) return;

      for (const file of files) {
        // opcional: evitar duplicação simples por nome+tamanho
        const jaExiste = this.laudosAnexados.some(
          (d) => d.nome === file.name && d.tamanho === file.size
        );
        if (jaExiste) continue;

        const base64 = await toBase64(file);
        const docUrl = URL.createObjectURL(file);

        this.visita.docs.push({
          id: 0,
          categoria: this.categoria,
          documento: base64,
          doc_url: docUrl,
          nome: file.name, // opcional (melhora UI)
          tamanho: file.size, // opcional
          _key: `${Date.now()}-${Math.random().toString(16).slice(2)}`, // opcional
        });
      }

      // permite selecionar o mesmo arquivo novamente depois
      this.$refs.anexarLaudo.value = "";
    },

    removerLaudo(doc) {
      const posGlobal = this.visita.docs.findIndex((d) => d === doc);
      if (posGlobal >= 0) this.visita.docs.splice(posGlobal, 1);
      if (doc && doc.doc_url) URL.revokeObjectURL(doc.doc_url);
    },
  },

  async mounted() {
    this.dialog = true;
    this.carregandoLaudo = true;

    // Se já existem laudos salvos (id > 0), busca o conteúdo de todos
    const existentes = this.laudosAnexados.filter((d) => d.id > 0);
    for (const doc of existentes) {
      await this.buscarDocumento(doc.id);
    }

    this.carregandoLaudo = false;
  },
};
</script>

<style>
</style>
